import { Controller } from '@hotwired/stimulus';
import { loadScript } from '@paypal/paypal-js';
import { patch } from '@rails/request.js';

// this controller is especially for the new booking process and kind of a copy of the old one
export default class extends Controller {
  static values = {
    clientId: String,
    locale: String,
    amount: String,
    onCancelUrl: String,
    onErrorUrl: String,
    prepareUrl: String,
    completeUrl: String,
    handlePaidUrl: String,
    bookingNumber: String
  };

  connect() {
    this.paypalRendered = false;
    this.confirmCheckbox = document.querySelector(
      'input[name="form[confirmed]"][type="checkbox"]'
    );
    this.boundOnConfirmChange = this.onConfirmChange.bind(this);

    if (this.confirmCheckbox) {
      this.confirmCheckbox.addEventListener('change', this.boundOnConfirmChange);
    }

    if (this.confirmCheckbox?.checked) {
      this.renderPaypal();
    } else {
      this.showPendingConfirmation();
    }
  }

  disconnect() {
    if (this.confirmCheckbox && this.boundOnConfirmChange) {
      this.confirmCheckbox.removeEventListener('change', this.boundOnConfirmChange);
    }
  }

  onConfirmChange(event) {
    if (event.target.checked && !this.paypalRendered) {
      this.element.innerHTML = '';
      this.renderPaypal();
    }
  }

  showPendingConfirmation() {
    this.element.innerHTML =
      '<p class="booking-form__hint"><em>Bitte bestätige zuerst die AGB, um mit PayPal zu bezahlen.</em></p>';
  }

  async renderPaypal() {
    let locale;
    switch (this.localeValue) {
      case 'de':
        locale = 'de_DE';
        break;
      case 'en':
        locale = 'en_US';
        break;
    }

    try {
      paypal = await loadScript({
        'client-id': this.clientIdValue,
        currency: 'EUR',
        intent: 'capture',
        locale: locale
      });
    } catch (error) {
      console.error('failed to load the PayPal JS SDK script', error);
    }

    if (paypal) {
      try {
        await paypal
          .Buttons({
            createOrder: async (data, actions) => {
              let orderId = await actions.order.create({
                purchase_units: [
                  {
                    reference_id: this.bookingNumberValue,
                    custom_id: this.bookingNumberValue,
                    amount: {
                      value: this.amountValue
                    }
                  }
                ]
              });

              const response = await this.handlePatch(
                this.prepareUrlValue,
                { paypal_order_id: orderId },
                'application/json'
              );

              localStorage.setItem('orderEventId', response.event_id);

              return orderId;
            },
            onCancel: async () => {
              await this.handlePatch(
                this.onCancelUrlValue,
                { event_id: this.eventId() },
                'application/json'
              );

              return true;
            },
            onError: async () => {
              await this.handlePatch(
                this.onErrorUrlValue,
                { event_id: this.eventId() },
                'application/json'
              );
            },
            onApprove: async (data, actions) => {
              const completeResponse = await this.handlePatch(
                this.completeUrlValue,
                { paypal_order_id: data.orderID, event_id: this.eventId() },
                'application/json'
              );

              if (!completeResponse.success) throw 'Payment not completed';

              window.location.href = this.handlePaidUrlValue;
            }
          })
          .render(`#${this.element.id}`);

        this.paypalRendered = true;
      } catch (error) {
        console.error('failed to render the PayPal Buttons', error);
      }
    }
  }

  handlePatch = async (url, body, responseKind) => {
    const response = await patch(url, { body, responseKind });

    if (response.statusCode == 409) {
      location.reload();
    }

    if (response.ok && responseKind === 'application/json') {
      return await response.json;
    }
  };

  eventId = () => {
    return localStorage.getItem('orderEventId');
  };
}
